import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    marginTop: 64,
    marginLeft: 16,
    marginRight: 16,
  },
  header: {
    height: 64,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: 8,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#C4C6C9',
    borderRadius: 16,
    marginBottom: 16,
  },
  nav: {
    width: '100%',
    height: 64,
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridGap: 16,
    overflow: 'hidden',
    marginBottom: 16,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'left',
    padding: 8,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#C4C6C9',
    borderRadius: 16,
    marginBottom: 16,
    boxShadow: '0px 2px 2px rgba(160, 161, 164, 0.25)',
    '&:last-child': {
      marginBottom: 72,
    },
  },
  sectionTitle: {
    textTransform: 'uppercase',
    textAlign: 'left',
    fontWeight: 700,
    fontSize: '2rem',
    marginBottom: 16,
  },
  sectionButtons: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridGap: 16,
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridGap: 16,
    },
  },
  grid: {
    justifyContent: 'space-around',
    alignItems: 'center',
    '& + &': {
      marginLeft: 16,
    },
  },
  button: {
    height: '56px',
    borderRadius: '16px',
    fontSize: 16,
    backgroundColor: 'rgba(160, 161, 164, 0.2)',
    transition: 'background-color 0.2s',

    '&:hover': {
      backgroundColor: 'rgba(160, 161, 164, 1)',
    },
  },
}));
